<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [yaxis]="chartOptions.yaxis!"
        [xaxis]="chartOptions.xaxis!"
        [labels]="chartOptions.labels!"
        [stroke]="chartOptions.stroke!"
        [plotOptions]="chartOptions.plotOptions!"
        [markers]="chartOptions.markers!"
        [grid]="chartOptions.grid!"
        [legend]="chartOptions.legend!"
        [fill]="chartOptions.fill!"
        [tooltip]="chartOptions.tooltip!"
    ></apx-chart>
</div>